var offsetX = 0;
var offsetY = -2.0;
var width = 70;
var height = 50;
var rotate = 90;
var marginX = 2.0;
var marginY = 2.0;
var titleFontSize = 5.6;
var titleWidth = width - marginX * 2
var titleHeight = 7.4;

var sheetHeight = 5.5;

var contentWidth = width - marginX * 3;
var contentHeight = 4.3;
var fontSize = 3.2;

var qrCodeHeight = height - marginY * 20;
var qrCodeWidth = qrCodeHeight;
//文本打印数据
export const outBoundPrintData = {

    InitDrawingBoardParam: {
        width: width,
        height: height,
        rotate: rotate,
        path: "ZT001.ttf",
        verticalShift: 0,
        HorizontalShift: 0
    },

    elements: [
        {
            type: 'text',
            json: {
                x: marginX + offsetX,
                y: marginY * 2 + offsetY,
                height: titleHeight,
                width: titleWidth,
                value: "上海芒可亿科技有限公司",
                fontFamily: "宋体",
                rotate: 0,
                fontSize: titleFontSize,
                textAlignHorizonral: 1,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [true, false, false, false],
            }
        },

        {
            type: 'text',
            json: {
                x: marginX * 1.5 + offsetX,
                y: marginY * 6.5 + offsetY,
                height: contentHeight,
                width: contentWidth,
                value: "型号：iPhone 13ProMax",
                fontFamily: "宋体",
                rotate: 0,
                fontSize: fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: marginX * 1.5 + offsetX,
                y: marginY * 6.5+sheetHeight + offsetY,
                height: contentHeight,
                width: contentWidth,
                value: "颜色：银色",
                fontFamily: "宋体",
                rotate: 0,
                fontSize: fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: marginX * 1.5 + offsetX,
                y: marginY * 6.5+sheetHeight*2  + offsetY,
                height: contentHeight,
                width: contentWidth,
                value: "内存：512G",
                fontFamily: "宋体",
                rotate: 0,
                fontSize: fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: marginX * 1.5 + offsetX,
                y: marginY * 6.5+sheetHeight*3 + offsetY,
                height: contentHeight,
                width: contentWidth,
                value: "电容：94%",
                fontFamily: "宋体",
                rotate: 0,
                fontSize: fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: marginX * 1.5 + offsetX,
                y: marginY * 6.5+sheetHeight*4 + offsetY,
                height: contentHeight,
                width: contentWidth,
                value: "成色：99新",
                fontFamily: "宋体",
                rotate: 0,
                fontSize: fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: marginX * 1.5 + offsetX,
                y: marginY * 6.5 + sheetHeight * 5 + offsetY,
                height: contentHeight,
                width: contentWidth,
                value: "序列号：KJCBSI29JS",
                fontFamily: "宋体",
                rotate: 0,
                fontSize: fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
    ]
};



// WEBPACK FOOTER //
// ./src/utils/printData/outBoundText.js